import {
  Box,
  Text,
  Checkbox,
  Flex,
  Grid,
  VStack,
  HStack,
  Tooltip,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

import DropdownWithText from '../../components/DropdownWithText';
import React, { useEffect, useState, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import {
  FormTextInput,
} from '@laxmimanogna/code-quick-components';
import accountsRepository from '../../../../repositories/AccountsRepository';
import AppColors from '../../../../constants/AppColors';

const AccountContactInput = ({
    fetchParentSpocList,
    onChange,
    fieldValue,
    isNewAccountContact,
    emailOptions,
    contactField,
    removeAccountContact,
    control,
    errors,
    handleCheckBox,
    handleCheckBoxUpload,
    selectedCanUploadCheckBoxIndex,
    canCreateWithoutEmail = false,
}) => {

  const [createWithoutEmail, setCreateWithoutEmail] = useState({});
    useEffect(() => {
        fetchParentSpocList();     
    }, []);

  function renderAddContactForm(field, index) {
    return (
      <React.Fragment key={field.id}>
        <Grid
          width={"95%"}
          templateColumns={{ sm: "1fr", md: "1fr 1fr", lg: "40% 30% 30%" }}
          gap={5}
          justifyItems="start"
        >
          
          <Controller
            name={`account_contact.${index}.email`}
            control={control}
            render={({field}) => (
        
              <VStack align={'start'} width={'100%'}>
              <DropdownWithText
                {...field}
                isDisabled={createWithoutEmail[index]}
                options={emailOptions || []}
                isLoading={emailOptions == null}
                noOptionsMessage={() =>
                  emailOptions == null ? 'Loading ...' : 'No options available'
                }
                onChange={(selectedOption) => onChange(selectedOption, field, index)}
                placeholder={"Select/Type Email"}
                value={fieldValue(field)}   
              />

              {errors?.account_contact?.[index]?.email && (
                <p style={{ color: 'red' }}>
                {errors.account_contact[index].email.message}
                  </p>
              )}
              </VStack>   
            )}
          />

          <Box width={'100%'} >
          <FormTextInput
            name={`account_contact.${index}.first_name`}
            height={'50px'}
            control={control}
            placeholder={'First Name'}
            size="md"
            readOnly={!isNewAccountContact[index] && !createWithoutEmail[index]}
            pl= '5px'
            cursor={!isNewAccountContact[index] && !createWithoutEmail[index] ? 'not-allowed' : 'text'}
            backgroundColor={!isNewAccountContact[index] && !createWithoutEmail[index] ? '#f0f0f0' : 'white'}
            color = {!isNewAccountContact[index] ? '#888' : 'black'}
            border = {'1px solid #ccc'}
            borderRadius = {'4px'}
            w = {'90%'}
            mr = "auto"     
          />
          </Box>

          <Box width={'100%'}>
          <FormTextInput
            name={`account_contact.${index}.last_name`}
            control={control}
            height={'50px'}
            placeholder={'Last Name'}
            size="md"
            readOnly={!isNewAccountContact[index] && !createWithoutEmail[index]}
            pl= '5px'
            cursor={!isNewAccountContact[index] && !createWithoutEmail[index] ? 'not-allowed' : 'text'}
            backgroundColor={!isNewAccountContact[index] && !createWithoutEmail[index] ? '#f0f0f0' : 'white'}
            color = {!isNewAccountContact[index] ? '#888' : 'black'}
            border = {'1px solid #ccc'}
            borderRadius = {'4px'}
            w = {'90%'}
            mr="auto"     
          />
          </Box>

          {index === 0 && <br />}
          <Text
            onClick={() => removeAccountContact(index)}
            cursor={'pointer'}
            color={AppColors.secondary}
            fontSize="sm"
            display={index > 0 ? 'block' : 'none'}
          >
            Remove
          </Text>
        {/* </SimpleGrid> */}
        </Grid>

        <Flex align="center" mb={5} mt={2}>
          <Checkbox
            onChange={e => handleCheckBox(e, index)}
            value={index.toString()}
          >
            Primary Account
          </Checkbox>
          <Checkbox
            onChange={e => handleCheckBoxUpload(e, index)}
            value={index.toString()}
            defaultChecked={selectedCanUploadCheckBoxIndex.includes(index)}
            ml={5}
          >
            Can Upload
          </Checkbox>
          {canCreateWithoutEmail && (<Checkbox
            ml={5}
            onChange={e => setCreateWithoutEmail(prev => ({
              ...prev,
              [index]: e.target.checked
            }))}
            isChecked={createWithoutEmail[index] || false}
          >
            <HStack spacing={1}>
              <Text fontSize="sm">
                Create client without email
              </Text>

              <Tooltip 
                label="Clients cannot log in until their email address is added. Managers can add the client's email at any time upon request." 
                placement="right"
                hasArrow
              >
                <InfoIcon 
                  color="gray.500" 
                  cursor="pointer" 
                  boxSize={4} 
                />
              </Tooltip>
            </HStack>
          </Checkbox>)}
        </Flex>
      </React.Fragment>
    );
  }

    return (
        <Box>{contactField.fields.map(renderAddContactForm)}</Box>
        
    );
}

export default AccountContactInput;